"use strict";
exports.__esModule = true;
exports.AlertSubType = void 0;
// ! Add the new alert sub types to the AlertAutoCloserService processAlertCloser method
var AlertSubType;
(function (AlertSubType) {
    AlertSubType["AccountUpdateRejected"] = "AccountUpdateRejected";
    AlertSubType["AccountUpdateNotUpdated"] = "AccountUpdateNotUpdated";
    AlertSubType["ACHReversal"] = "achReversal";
    AlertSubType["CashInActivityUpdateError"] = "CashInActivityUpdateError";
    AlertSubType["CashTransfer"] = "CashTransfer";
    AlertSubType["CashTransferRejected"] = "CashTransferRejected";
    AlertSubType["CashTransferStuck"] = "CashTransferStuck";
    AlertSubType["CustodianReject"] = "CustodianReject";
    AlertSubType["DepositRequestError"] = "depositRequestError";
    AlertSubType["DepositRequestRejected"] = "depositRequestRejected";
    AlertSubType["DepositStatusProcessingError"] = "DepositStatusProcessingError";
    AlertSubType["DepositStatusUpdateError"] = "DepositStatusUpdateError";
    AlertSubType["DestinationReject"] = "DestinationReject";
    AlertSubType["DisbursementRequest"] = "DisbursementRequest";
    AlertSubType["DisbursementRequestOther"] = "DisbursementRequestOther";
    AlertSubType["DisbursementRejected"] = "disbursementRejected";
    AlertSubType["DisbursementReversal"] = "DisbursementReversal";
    AlertSubType["DisbursementStatusUpdate"] = "DisbursementStatusUpdate";
    AlertSubType["DistributionRequest"] = "DistributionRequest";
    AlertSubType["ErrorAccountDebitBalance"] = "errorAccountDebitBalance";
    AlertSubType["FeeAllocationError"] = "FeeAllocationError";
    AlertSubType["FileReceiveError"] = "FileReceiveError";
    AlertSubType["FileSendError"] = "File Send Error";
    AlertSubType["FileSendNotConfirmed"] = "File Send Not Confirmed";
    AlertSubType["FileSendRejected"] = "FileSendRejected";
    AlertSubType["InboundFileSLABreach"] = "inboundFileSLABreach";
    AlertSubType["InvestmentUpdateRejected"] = "InvestmentUpdateRejected";
    AlertSubType["jobCompletionSLABreach"] = "jobCompletionSLABreach";
    AlertSubType["LoanRequest"] = "LoanRequest";
    AlertSubType["NewConversionDeposit"] = "NewConversionDeposit";
    AlertSubType["NewRolloverDeposit"] = "NewRolloverDeposit";
    AlertSubType["OrderExited"] = "orderExited";
    AlertSubType["OrderReconfirmed"] = "orderReconfirmed";
    AlertSubType["OutboundFileSLABreach"] = "outboundFileSLABreach";
    AlertSubType["PlanLiquidationDisbursementRejected"] = "PlanLiquidationDisbursementRejected";
    AlertSubType["ProcessInboundError"] = "ProcessInboundError";
    AlertSubType["ProcessingSLABreach"] = "ProcessingSLABreach";
    AlertSubType["ReconciliationError"] = "ReconciliationError";
    AlertSubType["SecurityMasterFetchError"] = "SecurityMasterFetchError";
    AlertSubType["SecurityMasterLoadError"] = "SecurityMasterLoadError";
    AlertSubType["UnclassifiedDeposit"] = "UnclassifiedDeposit";
    AlertSubType["UnexpectedStatusUpdate"] = "unexpectedStatusUpdate";
    AlertSubType["UnknownAccount"] = "UnknownAccount";
    AlertSubType["UnknownDisbursement"] = "unknownDisbursement";
    AlertSubType["UnknownOrder"] = "UnknownOrder";
    AlertSubType["UnmatchedCashTransfer"] = "UnmatchedCashTransfer";
    AlertSubType["UnmatchedInvestmentUpdate"] = "UnmatchedInvestmentUpdate";
    AlertSubType["QueueIndividualSubAccountOrder"] = "queueIndividualSubAccountOrder";
    AlertSubType["OrderCustodianUnitSellOffset"] = "OrderCustodianUnitSellOffset";
    AlertSubType["OrderCustodianAmountUndersellOffset"] = "OrderCustodianAmountUndersellOffset";
    AlertSubType["UnsupportedCustodianTransactionType"] = "UnsupportedCustodianTransactionType";
    AlertSubType["UnclassifiedWithdrawal"] = "UnclassifiedWithdrawal";
    AlertSubType["MissingRothBasis"] = "MissingRothBasis";
    AlertSubType["MissingVestingSchedule"] = "MissingVestingSchedule";
    AlertSubType["CashTransferProcessingError"] = "CashTransferProcessingError";
    AlertSubType["RefreshReconProcessingError"] = "RefreshReconProcessingError";
    AlertSubType["FeeRequestProcessingError"] = "FeeRequestProcessingError";
    AlertSubType["DepositRequestProcessingError"] = "DepositRequestProcessingError";
    AlertSubType["DistroRequestProcessingError"] = "DistroRequestProcessingError";
    AlertSubType["DividendsProcessingError"] = "DividendsProcessingError";
    AlertSubType["FlattenRequestProcessingError"] = "FlattenRequestProcessingError";
    AlertSubType["IndividualSubAccountOrderProcessingError"] = "IndividualSubAccountOrderProcessingError";
    AlertSubType["InvestContributionProcessingError"] = "InvestContributionProcessingError";
    AlertSubType["OrderDeaggProcessingError"] = "OrderDeaggProcessingError";
    AlertSubType["ReversalProcessingError"] = "ReversalProcessingError";
    AlertSubType["TradeRequestProcessingError"] = "TradeRequestProcessingError";
    AlertSubType["FullLiqProcessingError"] = "FullLiqProcessingError";
    AlertSubType["RebalanceProcessingError"] = "RebalanceProcessingError";
    AlertSubType["SwapProcessingError"] = "SwapProcessingError";
    AlertSubType["CashInterestPaymentProcessingError"] = "CashInterestPaymentProcessingError";
    AlertSubType["AllocateDepositProcessingError"] = "AllocateDepositProcessingError";
    AlertSubType["ReconProcessingError"] = "ReconProcessingError";
    AlertSubType["CashFlatteningProcessingError"] = "CashFlatteningProcessingError";
    AlertSubType["AdvancedCorrectionProcessingError"] = "AdvancedCorrectionProcessingError";
    AlertSubType["InvestmentUpdateProcessingError"] = "InvestmentUpdateProcessingError";
    AlertSubType["SpecificSecuritiesProcessingError"] = "SpecificSecuritiesProcessingError";
    AlertSubType["ContributionUsingCurrentProcessingError"] = "ContributionUsingCurrentProcessingError";
    AlertSubType["ContributionUsingTargetProcessingError"] = "ContributionUsingTargetProcessingError";
    AlertSubType["WithdrawalUsingCurrentProcessingError"] = "WithdrawalUsingCurrentProcessingError";
    AlertSubType["CashFixerProcessingError"] = "CashFixerProcessingError";
    AlertSubType["CheckDepositReversal"] = "CheckDepositReversal";
    AlertSubType["MoveTransactionProcessingError"] = "MoveTransactionProcessingError";
    AlertSubType["UnhandledCustodianTransaction"] = "UnhandledCustodianTransaction";
    AlertSubType["UnknownCheck"] = "UnknownCheck";
    AlertSubType["CheckPostivePayException"] = "CheckPostivePayException";
    AlertSubType["FundMergeProcessingError"] = "FundMergeProcessingError";
    AlertSubType["ExternalTransferProcessingError"] = "ExternalTransferProcessingError";
    AlertSubType["AccountPerformanceProcessingError"] = "AccountPerformanceProcessingError";
    AlertSubType["MarketValueAdjustmentError"] = "MarketValueAdjustmentError";
    AlertSubType["MissingExternalAssetBalance"] = "MissingExternalAssetBalance";
    AlertSubType["CheckStopValidationFailVW"] = "CheckStopValidationFailVW";
    AlertSubType["CheckStopRequestRejected"] = "CheckStopRequestRejected";
})(AlertSubType = exports.AlertSubType || (exports.AlertSubType = {}));
